"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProdEnvironment = exports.isDevEnvironment = exports["default"] = exports.DEBUG = void 0;
var isDevEnvironment = exports.isDevEnvironment = process.env.NODE_ENV === 'development';
var isProdEnvironment = exports.isProdEnvironment = process.env.NODE_ENV === 'production';

// set DEBUG to true to enable logging at app level
var DEBUG = exports.DEBUG = false;
var config = {
  appVersion: process.env.REACT_APP_VERSION,
  appPackage: process.env.REACT_APP_NAME,
  googleAuthResponseType: 'code',
  apiURL: process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || process.env.NEXT_PUBLIC_IDENTITY_POOL_ID,
  region: process.env.REACT_APP_REGION || process.env.NEXT_PUBLIC_REGION,
  userPoolId: process.env.REACT_APP_USER_POOL_ID || process.env.NEXT_PUBLIC_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || process.env.NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID,
  googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS,
  s3Bucket: process.env.REACT_APP_S3_BUCKET || process.env.NEXT_PUBLIC_S3_BUCKET,
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN || process.env.NEXT_PUBLIC_COGNITO_DOMAIN,
  redirectUrl: process.env.REACT_APP_REDIRECT_URL || process.env.NEXT_PUBLIC_REDIRECT_URL,
  signoutRedirectUrl: process.env.REACT_APP_SIGNOUT_REDIRECT_URL || process.env.NEXT_PUBLIC_SIGNOUT_REDIRECT_URL,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  sentryDns: process.env.REACT_APP_SENTRY_DNS,
  userPilotUrl: process.env.REACT_APP_USERPILOT_URL,
  remoteResourceUrl: process.env.REACT_APP_NETWORK_CHECK_REMOTE_RESOURCE_URL,
  userConfigDynamoInvokeUrl: process.env.REACT_APP_DYNAMODB_USER_CONFIG_URL,
  s3FileUrl: function s3FileUrl(name) {
    return "".concat(process.env.REACT_APP_S3_FILE_URL).concat(name);
  },
  cloudApiUrl: process.env.REACT_APP_CLOUD_API_URL,
  loginUrl: process.env.REACT_APP_LOGIN_URL || process.env.NEXT_PUBLIC_LOGIN_URL,
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN || process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  mainAppUrl: process.env.REACT_APP_MAIN_URL || process.env.NEXT_PUBLIC_MAIN_URL,
  mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN
};
var _default = exports["default"] = config;